import styled from '@emotion/styled';
import { Autocomplete } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useContext } from 'react';
import { Context } from '../../store/context';

const Input = styled('input')(() => ({
  width: '100%',
  boxSizing: `border-box`,
  border: `1px solid transparent`,
  height: `60px`,
  padding: `0 12px`,
  borderRadius: `3px`,
  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
  fontSize: `14px`,
  outline: `none`,
  textOverflow: `ellipses`,
  '@media(max-width: 768px)': {
    height: `40px`,
  },
}));

const Wrapper = styled('div')(() => ({
  width: '95%',
  marginBottom: '20px',
  '@media(max-width: 768px)': {
    marginBottom: `15px`,
  },
}));

function AutoCompleteInput({ isLoaded }) {
  const { map, center, setLastCenter, setLastZoom } = useContext(Context);

  const [autoComplete, setAutoComplete] = useState();

  const inputRef = useRef();

  const onLoad = (autocomplete) => {
    setAutoComplete(autocomplete);
  };

  const onPlaceChanged = async () => {
    if (autoComplete !== null) {
      let { lat, lng } = autoComplete.getPlace().geometry.location;
      map.setCenter({ lat: lat(), lng: lng() } || center);
      map.setZoom(14);
      setLastCenter({ lat: lat(), lng: lng() } || center);
      setLastZoom(14);
      inputRef.current.value = '';
    }
  };

  return (
    <>
      <Wrapper>
        {isLoaded === true ? (
          <Autocomplete
            onLoad={onLoad}
            onPlaceChanged={onPlaceChanged}
            bounds={new window.google.maps.LatLngBounds(center)}
          >
            <Input
              ref={inputRef}
              type="text"
              placeholder="Ingresa una ubicación"
            />
          </Autocomplete>
        ) : null}
      </Wrapper>
    </>
  );
}

AutoCompleteInput.propTypes = {
  isLoaded: PropTypes.bool,
};

export default AutoCompleteInput;
